import { FC, memo } from 'react';

import { AvatarPlaceholder, AvatarPlaceholderType } from '@gem/components';
import { Skeleton } from '@gem/ui-kit';

import { useSyncAnimations } from '../hooks/useSyncAnimations';
import styles from './MentionsPlaceholder.styles.m.css';

interface MentionsPlaceholderProps {
  count?: number;
}

export const MentionsPlaceholder: FC<MentionsPlaceholderProps> = memo((props) => {
  const { count = 3 } = props;

  const { isFirstAnimated, isSecondAnimated } = useSyncAnimations({
    firstTimeout: 500,
    secondTimeout: 1000,
  });

  return Array.from({ length: count }, (_, key) => {
    return (
      <div
        key={key}
        className={styles.container}
      >
        <AvatarPlaceholder
          type={AvatarPlaceholderType.Round_0}
          isAnimated={isFirstAnimated}
        />
        <div className={styles.content}>
          <Skeleton
            width="140px"
            height="14px"
            borderRadius="6px"
            animationConfig={{
              duration: 1000,
              startPosition: '-16px',
              endPosition: '200px',
            }}
            className={styles.firstLine}
            isAnimated={isSecondAnimated}
          />
          <Skeleton
            width="110px"
            height="8px"
            borderRadius="6px"
            animationConfig={{
              startPosition: '-16px',
              duration: 1000,
              endPosition: '200px',
            }}
            isAnimated={isSecondAnimated}
          />
        </div>
      </div>
    );
  });
});
